__turbopack_context__.v({
  "Content": "footer-module-scss-module__-ldrxq__Content",
  "mailLink": "footer-module-scss-module__-ldrxq__mailLink",
});
